import * as React from 'react'

import { Tooltip, helpIcon, } from '../../../../../Shared/index'

const MY_DIAGNOSTICS_PATH = '/teachers/progress_reports/diagnostic_reports/diagnostics'

interface ReportHeaderProps {
  children?: React.ReactNode;
  guideLink?: React.ReactNode;
  pageName: string;
  subHeader: string;
  tooltipText?: string;
}

const ReportHeader = ({ children, guideLink, pageName, subHeader, tooltipText, }: ReportHeaderProps) => {
  const heading = (
    <h1>
      <a className="focus-on-light" href={MY_DIAGNOSTICS_PATH}>My Diagnostics</a>
      <span aria-hidden="true" className="slash">/</span>
      <span className="report-name">{pageName}</span>
    </h1>
  )

  return (
    <header className="report-header">
      <div className="upper-header-section">
        <div className="report-header-text">
          {tooltipText ? (
            <div className="heading-and-tooltip">
              {heading}
              <Tooltip
                isTabbable={false}
                tooltipText={tooltipText}
                tooltipTriggerText={<button aria-label="About this report" className="interactive-wrapper focus-on-light" type="button"><img alt="" src={helpIcon.src} /></button>}
              />
            </div>
          ) : heading}
          <p className="sub-header">{subHeader}</p>
        </div>
        {guideLink}
      </div>
      {children}
    </header>
  )
}

export default ReportHeader
